<!-- src/components/VuePikaday.vue -->

<template>
    <input
        class="vue-pikaday inline-block sm:text-sm border border-gray-300 p-2"
        type="text"
        v-model="current"
        @blur="updatedDate($event.target.value)" />
</template>

<script>

import Pikaday from 'pikaday';
import Moment from 'moment';

export default {
    props: [ "value", "startdate", "enddate" ],

    data () {
        return {
            current: "",
            picker: null,
            counter: 0
        }
    },

    mounted () {
      const self = this;
        this.picker = new Pikaday({
            field: this.$el,
            onSelect: function(date) {
                self.updatedDate(this.getMoment());
            },
        });

        if (this.value) {
            this.picker.setMoment(Moment(this.value));
        }
    },

    methods: {
      /**
       * @param {moment.Moment} date
       */
      updatedDate(date) {
          if (typeof date === 'object' && date.isValid()) {
              this.current = date.format("MM/DD/YYYY");
              const serverDate = date.format("YYYY-MM-DD");
              if (serverDate !== this.value) {
                  this.$emit('input', serverDate);
              }
          }
      }

    },

    watch: {
        "value": function(newVal, oldVal) {
            if (newVal) {
              this.picker.setMoment(Moment(newVal));
            }
            else {
                this.current = "";
            }
        },
        "startdate": function(){
          if (this.startdate !== null) {
            this.picker.setMinDate(new Date(this.startdate));
          }
        },
        "enddate": function(){
          if (this.enddate !== null) {
            this.picker.setMaxDate(new Date(this.enddate));
          }
        }
    }

}

</script>

<style>

/*!
 * Pikaday
 * Copyright © 2014 David Bushell | BSD & MIT license | http://dbushell.com/
 */

.pika-single {
    z-index: 9999;
    position: absolute;
    color: #333;
    background: #fff;
    border: 1px solid #ddd;
    border-bottom-color: #bbb;
    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
    /* font-family: "Helvetica Neue", Helvetica, Arial, sans-serif; */
    border-radius: 3px;
    margin-top: 10px;
}

.pika-single:before,
.pika-single:after {
    bottom: 100%;
    left: 50%;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
}

.pika-single:after {
    clear: both;
    border-color: rgba(255, 255, 255, 0);
    border-bottom-color: #FFF;
    border-width: 7px;
    margin-left: -12px;
}

.pika-single:before {
    border-color: rgba(221, 221, 221, 0);
    border-bottom-color: #ddd;
    border-width: 8px;
    margin-left: -13px;
    border-radius: 3px;
}

.pika-single {
    zoom: 1;
}

.pika-single.is-hidden {
    display: none;
}

.pika-single.is-bound {
    position: absolute;
    box-shadow: 0 5px 15px -5px rgba(0,0,0,.5);
}


.pika-lendar {
    float: left;
    width: 240px;
    margin: 8px;
}

.pika-title {
    position: relative;
    text-align: center;
}

.pika-label {
    display: inline-block;
    position: relative;
    z-index: 9999;
    overflow: hidden;
    margin: 0;
    padding: 5px 3px;
    font-size: 14px;
    line-height: 20px;
    font-weight: bold;
    background-color: #fff;
}

.pika-title select {
    cursor: pointer;
    position: absolute;
    z-index: 9998;
    margin: 0;
    left: 0;
    top: 5px;
    opacity: 0;
}


.pika-prev,
.pika-next {
    display: block;
    cursor: pointer;
    position: relative;
    outline: none;
    border: 0;
    padding: 0;
    width: 20px;
    height: 30px;
    text-indent: 20px;
    white-space: nowrap;
    overflow: hidden;
    background-color: transparent;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: 75% 75%;
    opacity: .5;
    position: absolute;
    top: 0;
}

.pika-prev:hover,
.pika-next:hover {
  opacity: 1
}

.pika-prev,
.is-rtl .pika-next {
  float: left;
  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAeCAYAAAAsEj5rAAAAUklEQVR42u3VMQoAIBADQf8Pgj+OD9hG2CtONJB2ymQkKe0HbwAP0xucDiQWARITIDEBEnMgMQ8S8+AqBIl6kKgHiXqQqAeJepBo/z38J/U0uAHlaBkBl9I4GwAAAABJRU5ErkJggg==');
  left: 0;
}

.pika-next,
.is-rtl .pika-prev {
  float: right;
  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAeCAYAAAAsEj5rAAAAU0lEQVR42u3VOwoAMAgE0dwfAnNjU26bYkBCFGwfiL9VVWoO+BJ4Gf3gtsEKKoFBNTCoCAYVwaAiGNQGMUHMkjGbgjk2mIONuXo0nC8XnCf1JXgArVIZAQh5TKYAAAAASUVORK5CYII=');
  right: 0;
}

.pika-prev.is-disabled,
.pika-next.is-disabled {
    cursor: default;
    opacity: .2;
}

.pika-select {
    display: inline-block;
}

.pika-table {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    border: 0;
}

.pika-table th,
.pika-table td {
    width: 14.285714285714286%;
    padding: 0;
}

.pika-table th {
    color: #999;
    font-size: 12px;
    line-height: 25px;
    font-weight: bold;
    text-align: center;
}


.pika-button {
    cursor: pointer;
    display: block;
    box-sizing: border-box;
    outline: none;
    border: 0;
    margin: 0;
    width: 100%;
    padding: 5px;
    color: #666;
    font-size: 12px;
    line-height: 15px;
    text-align: right;
    background: #f5f5f5;
}


.pika-week {
    font-size: 11px;
    color: #999;
}

.is-today .pika-button {
    color: var(--primary-color1);
    font-weight: bold;
}

.is-selected .pika-button {
    color: #fff;
    font-weight: bold;
    background: var(--primary-color1);
    box-shadow: inset 0 1px 3px #178fe5;
    border-radius: 3px;
}

.is-inrange .pika-button {
    background: #D5E9F7;
}

.is-startrange .pika-button {
    color: #fff;
    background: #6CB31D;
    box-shadow: none;
    border-radius: 3px;
}

.is-endrange .pika-button {
    color: #fff;
    background: #33aaff;
    box-shadow: none;
    border-radius: 3px;
}

.is-disabled .pika-button,
.is-outside-current-month .pika-button {
    pointer-events: none;
    cursor: default;
    color: #999;
    opacity: .3;
}


.pika-button:hover {
    color: #fff;
    background: var(--primary-color1);
    box-shadow: none;
    border-radius: 3px;
}

.pika-table abbr {
    border-bottom: none;
    cursor: help;
}
</style>
